// React
import React, { Component } from "react";
import Transition from 'react-transition-group/Transition';

// Libraries
import Numeral from 'numeral';

// Stores
import { PricingStore, CurrencyStore } from '../../Stores';

// Styles
import './positions.css';
import './dashboard-flex.css';
import '../Prices/pricer.css';

class Position extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            price : 0,
            pnl : 0,
            pnlPercent : 0
        };
                  
    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all parameters and the corresponding chart
    componentDidMount() {

        //console.log('Position.componentDidMount()');

        this.getInitialPrice(this.getTopic())
            .then( (price) => {

                this.trackPrice();

                const updated = this.calculatePnl(price.price);
                
                this.setState((prev, props) => {
                    return {
                        price : updated.price,
                        pnl : updated.pnl,
                        pnlPercent : updated.pnlPercent
                    }
                });

            }).catch( (error) => {
                // todo: something
            });

    }


/**********************************************************
 *  Functions
 **********************************************************/

    // Given a topic, determine its components and retrieve 
    // the latest price
    getInitialPrice(topic) {
    
        return new Promise( (resolve, reject) => {
    
            PricingStore.getPrice(topic)
                .then( (response) => {
                    resolve(response);
                })
                .catch( (error) => {
                    reject(error);
                });
    
        });
        
    }

    // Track the price and update pnl accordingly
    trackPrice() {

        //console.log('Position.trackPrice()');

        // Check to make sure socket exists
        if(this.props.socket !== null) {

            const topic = this.getTopic();

            this.props.socket.on(topic, (priceObj) => {
                
                if(priceObj.id === topic) {
                    this.updatePrice(priceObj);
                }
        
            });

        }
        
    }


    // Update the current price and percentage change
    updatePrice(newPrice) {

        //console.log('Position.updatePrice(' + newPrice.price + ')');

        const updated = this.calculatePnl(newPrice.price);

        this.setState((prev, props) => {
            return {
                price : updated.price,
                pnl : updated.pnl,
                pnlPercent : updated.pnlPercent
            }
        });

    }


    // Given the new price, calculate the updated pnl in dollars and percent
    calculatePnl(newPrice) {

        var position = this.props.position;
        
        var pnl = parseFloat((newPrice - position.price) * position.volume).toFixed(2);
        
        var pnlPercent = parseFloat((pnl / position.price) * 100).toFixed(2);

        return {
            pnl : pnl,
            pnlPercent : pnlPercent,
            price : newPrice
        };

    }


    // Derive the topic from the name
    getTopic() {

        //console.log('Position.getTopic()');

        // todo: this is a bandaid fix at best
        var quoteCurrency = this.props.position.quoteCurrency === 'XBT' ? 'BTC' : this.props.position.quoteCurrency;
        var baseCurrency = this.props.position.baseCurrency === 'XBT' ? 'BTC' : this.props.position.baseCurrency;

        const topic = baseCurrency + '-' + this.props.position.exchange + '-' + quoteCurrency;

        return topic;

    }

    // Returns the order section, condensed and expanded
    buildOrderSection = (position, condensed) => {

        var bottomRow = null;

        if(!condensed)  {
            bottomRow = (
                <div className='row-holder'>
                    {/* Bottom Left */}
                    <div className="row-box left">
                        <div>
                            { position.type }
                            <span className="label label-flat label-info left-pad">{ position.leverage }:1</span>
                        </div>

                        <div className="italic">
                            { position.exchange }
                        </div>
                    </div>
                    {/* Bottom Right */}
                    <div className="row-box right">
                        <div className='colored-title'>Order Total</div>

                        <div>
                            <span className="right-pad">{ position.symbol }</span>
                            { 
                                position.total > 1 ?
                                Numeral(position.total).format(CurrencyStore.getDecimalsFormat(2)) :
                                Numeral(position.total).format(CurrencyStore.getFormat(position.quoteCurrency)) 
                            }
                        </div>

                    </div>
                </div>
            );
        }

        return (
            <div className='position-section'>

                <div className='position-title'>
                    <div className='top-border'></div>
                    <div className='the-title'>Order</div>
                    <div className='top-border'></div>
                </div>

                <div className="position-content">

                    <div className='row-holder'>
                        
                        {/* Top Left */}
                        <div className="column-box left">
                            <div>
                                <i className={ position.type === "buy" ? 'icon-sort green-text right-pad' : 'icon-sort red-text right-pad' }></i>
                            </div>
                            <div className="row-box left">
                                <div>{ position.baseCurrency } </div>
                                <div>{ position.quoteCurrency } </div>
                            </div>
                        </div>

                        {/* Top Right */}
                        <div className="row-box right">
                            <div>
                                { 
                                    position.volume > 1 ?
                                    Numeral(position.volume).format(CurrencyStore.getDecimalsFormat(2)) : 
                                    Numeral(position.volume).format(CurrencyStore.getFormat(position.baseCurrency)) 
                                }
                            </div>
                            <div>
                                <span className="right-pad">{ CurrencyStore.getCurrencySymbol(position.quoteCurrency) }</span>
                                { 
                                    position.price > 1 ?
                                    Numeral(position.price).format(CurrencyStore.getDecimalsFormat(2)) :
                                    Numeral(position.price).format(CurrencyStore.getFormat(position.quoteCurrency))
                                }
                            </div>
                        </div>

                    </div>
                    

                    { bottomRow }
                </div>

            </div>
        )

    }

    // Return the live section consisting of live price and current 
    buildLiveSection = (position, condensed) => {

        var bottomRow = null;

        if(!condensed)  {
            bottomRow = (
                <div className='row-holder right'>
                    {/* Bottom */}
                    <div className="row-box right">

                        <div className='colored-title'>Current Total</div>
                        <Transition timeout={750} in={true} mountOnEnter={true} appear={true}>
                        {(status) => (
                            <div className={`blinker blink-${status}`}>
                                <span className="right-pad">{ position.symbol }</span>
                                { 
                                    (this.state.price*position.volume) > 1 ?
                                    Numeral(this.state.price*position.volume).format(CurrencyStore.getDecimalsFormat(2)) :
                                    Numeral(this.state.price*position.volume).format(CurrencyStore.getFormat(position.quoteCurrency)) 
                                }
                            </div>
                        )}
                        </Transition>

                    </div>
                </div>
            );
        }

        return (
            <div className='position-section'>

                <div className='position-title'>
                    <div className='top-border'></div>
                    <div className='the-title'>Live</div>
                    <div className='top-border'></div>
                </div>

                <div className="position-content">
                    <div className='row-holder right'>

                        <div className="row-box right">
                            <div className='colored-title'>
                                Live {position.baseCurrency}
                            </div>
                            <Transition timeout={750} in={true} mountOnEnter={true} appear={true}>
                            {(status) => (
                                <div className={`blinker blink-${status}`}>
                                    <span className={"right-pad"}>{ CurrencyStore.getCurrencySymbol(position.quoteCurrency) }</span>
                                    { 
                                        this.state.price > 1 ?
                                        Numeral(this.state.price).format(CurrencyStore.getDecimalsFormat(2)) :
                                        Numeral(this.state.price).format(CurrencyStore.getFormat(position.quoteCurrency)) 
                                    }
                                </div>
                            )}
                            </Transition>
                        </div>

                    </div>
                
                    { bottomRow }
                </div>

            </div>
        )
    }

    // Return the pnl section with calculations in % and value
    // Show the dollar value on the top in condensed mode
    buildPnlSection = (position, condensed) => {

        var bottomRow = null;

        var percentClass = 'pnl-percent bigloss';
        if(this.state.pnlPercent > -30)
            percentClass = 'pnl-percent loss';
        if(this.state.pnlPercent > 0)
            percentClass = 'pnl-percent gain';

        if(!condensed)  {

            bottomRow = (
                <div className='row-holder right'>
                    <div className="row-box right">
                        <div className='colored-title'>Profit/Loss($)</div>
                        <div>
                            <span className="right-pad">{ CurrencyStore.getCurrencySymbol(position.quoteCurrency) }</span>
                            { 
                                this.state.pnl > 1 ?
                                Numeral(this.state.pnl).format(CurrencyStore.getDecimalsFormat(2)) :
                                Numeral(this.state.pnl).format(CurrencyStore.getFormat(position.quoteCurrency))
                            }
                            <i className={this.state.pnl > 0 ? 'icon-arrow-up8 green-text left-pad arrow hover-up' : 'icon-arrow-down8 red-text left-pad arrow hover-down'}></i>
                        </div>
                    </div>
                </div>
            );

            return (
                <div className='position-section'>
    
                    <div className='position-title'>
                        <div className='top-border'></div>
                        <div className='the-title'>Pnl</div>
                        <div className='top-border'></div>
                    </div>
    
                    <div className="position-content">
                        <div className='row-holder right'>
                            <div className="row-box right">
                                <div className='colored-title'>Profit/Loss(%)</div>
                                <div className={percentClass}>
                                    {this.state.pnlPercent} %
                                </div>
                            </div>
                        </div>
                    
                        { bottomRow }
                    </div>
    
                </div>
            )
        }
        else {

            return (
                <div className='position-section'>
    
                    <div className='position-title'>
                        <div className='top-border'></div>
                        <div className='the-title'>Pnl</div>
                        <div className='top-border'></div>
                    </div>
    
                    <div className="position-content">
                        <div className='row-holder right'>
                            <div className="row-box right">
                                <div className='colored-title'>Profit/Loss($)</div>
                                <div className={percentClass}>
                                    <span className="right-pad">{ CurrencyStore.getCurrencySymbol(position.quoteCurrency) }</span>
                                    { 
                                        this.state.pnl > 1 ?
                                        Numeral(this.state.pnl).format(CurrencyStore.getDecimalsFormat(2)) :
                                        Numeral(this.state.pnl).format(CurrencyStore.getFormat(position.quoteCurrency))
                                    }
                                    <i className={this.state.pnl > 0 ? 'icon-arrow-up8 green-text left-pad arrow hover-up' : 'icon-arrow-down8 red-text left-pad arrow hover-down'}></i>
                                </div>
                            </div>
                        </div>
                    
                        { bottomRow }
                    </div>
    
                </div>
            )
        }

    }

/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('Position.render()');

    const position = this.props.position;
    const condensed = this.props.condensed;

    return (
        <div className="flex-panel" style={{padding:'0 5px'}}>
            
            <div className="child-row">

                { this.buildOrderSection(position, condensed) }

                { this.buildLiveSection(position, condensed) }

                { this.buildPnlSection(position, condensed) }

            </div>

        </div>
    );

  }
}

export default Position;



// WEBPACK FOOTER //
// ./src/Views/Dashboard/Position.js